import { environment } from '../../environments/environment';

/**
 * Monta URL do microserviço financeiro no formato Azure Functions:
 * `{base}/api/{resource}{suffix}?code={key}`
 *
 * Evita colar `?code=` na URL base do environment (que quebra `${base}/endpoint`).
 */
export function buildFinancialApiUrl(resource: string, pathSuffix = ''): string {
  const raw = (environment.microservices.financial || '').trim();
  const [basePart, queryPart] = raw.split('?');
  let base = basePart.replace(/\/$/, '');

  const isApim = /azure-api\.net/i.test(base);
  // APIM expõe o prefixo do produto; o backend Functions usa `/api/{recurso}`.
  if (isApim && !/\/api$/i.test(base)) {
    base = `${base}/api`;
  }

  let code = (environment.functionKey || '').trim();
  if (!code && queryPart) {
    code = new URLSearchParams(queryPart).get('code') || '';
  }

  const res = resource.replace(/^\//, '').replace(/\/$/, '');
  const suffix = pathSuffix
    ? pathSuffix.startsWith('/')
      ? pathSuffix
      : `/${pathSuffix}`
    : '';
  const path = `${base}/${res}${suffix}`;

  // APIM: JWT/subscription — não enviar `?code=` de Function.
  if (!code || isApim) {
    return path;
  }
  const joiner = path.includes('?') ? '&' : '?';
  return `${path}${joiner}code=${encodeURIComponent(code)}`;
}
